export default __webpack_public_path__ + "static/media/loading.4b4fcbbe.svg";